export default "__VITE_ASSET__Ds1bCDy5__";